export default {"src":"/_next/static/media/param-double-arrow.fc598ef3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};